import _ from 'lodash';

export const validateDimensions = async (fileResult, dimensions) => {
  const img = new Image();
  return new Promise((resolve) => {
    img.src = fileResult;
    img.onload = () => {
      let isValidDimensions = false;
      dimensions.forEach((dimension) => {
        isValidDimensions = isValidDimensions
          || (img.height === dimension.height && img.width === dimension.width);
      });
      return resolve(isValidDimensions);
    };
    img.onerror = () => {
      resolve('error');
    };
  });
};

export const validateFileFormat = (type, formats) => formats.includes(type);



// WEBPACK FOOTER //
// ./src/modules/utils/file-upload/file-helpers.js